import React from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { User } from '../interfaces/user'
import formatBelgianPhoneNumber from '../fonctions/formatBelgiumPhone'
import { Event } from '../interfaces/event'
import GalleryCards from './GalleryCards'
import { API_BASE_URL, X_API_KEY } from '../../services/api'

interface EventCardProps {
  event: Event
  user: User
  gallery: {
    id: number
    fileUrl: string
    fileName: string
    cover?: boolean
    status: number
  }[]
  statusToShow: number[]
}

export const EventCard: React.FC<EventCardProps> = ({
  event,
  user,
  gallery,
  statusToShow,
}) => {
  const navigate = useNavigate()
  const location = useLocation()

  const formatURL = (title: string, id: number) => {
    return `${title
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')}/${id}`
  }

  const handleClick = async (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
  ) => {
    e.preventDefault()
    if (!event.id) return

    try {
      const response = await fetch(`${API_BASE_URL}/event/${event.id}/view`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'x-api-key': X_API_KEY || '',
        },
      })

      if (!response.ok) {
        throw new Error('Network response was not ok')
      }

      const data = await response.json()

      navigate(`/event/${formatURL(event.title, event.id)}`, {
        state: {
          from: location.pathname,
          eventData: data,
        },
      })
    } catch (error) {
      console.error('Error:', error)
    }
  }

  if (!event.id) return null

  return (
    <Link
      key={event.id}
      to={`/event/${formatURL(event.title, event.id)}`}
      className='group bg-grisclair text-redpink hover:bg-redpink transition-all rounded-lg shadow-md'
      style={{
        fontFamily: 'Poppins, sans-serif',
      }}
      onClick={handleClick}
    >
      <div className='overflow-hidden rounded-t-lg h-44'>
        <GalleryCards
          gallery={gallery}
          coverImage={gallery.find(img => img.cover)}
          gender={user?.userProfile?.gender || ''}
          statusToShow={statusToShow}
          customDefaultImage='/images/silouhette-event.jpg'
        />
      </div>

      <div className='text-center p-3'>
        <p className='text-redpink uppercase font-bold group-hover:text-white transition-all'>
          {event.title}
        </p>
        <p className='text-anthracite group-hover:text-white group-hover:opacity-80 transition-all'>
          {user.address?.zip_code} {user.address?.city}
        </p>
        <p className='text-anthracite group-hover:text-white group-hover:opacity-80 transition-all'>
          {user.address?.number} {user.address?.street}
        </p>

        <p className='text-anthracite group-hover:text-white group-hover:opacity-80 transition-all'>
          {user.phone ? formatBelgianPhoneNumber(user.phone) : 'N/A'}
        </p>
      </div>
    </Link>
  )
}

export default EventCard
